import React from 'react';

import styles from './Tab.Content.module.scss';

export interface ITabContentProps {
  active?: boolean;
  className?: string;
  dataTest?: string;
  id?: string;
}

export const TabContent: React.SFC<ITabContentProps> = (props) => (
  <div
    role="tabpanel"
    id={props.id}
    data-test={`tab-content-${props.dataTest}`}
    className={`${styles.tabContentArea} ${props.className}`}
  >
    {props.active && props.children}
  </div>
);
